import React, { FunctionComponent, useContext } from 'react';
import styles from './three-column-grid.module.scss';
import classNames from 'classnames/bind';
import Section from '../section/section';
import { SpaceBetweenColumnsType } from '../../typings';
import { DeviceType } from '../../typings';
import { AppStore } from '../../store/app.context';
import { checkDevice, marginBetweenItemsClasses } from '../../utils/utils';

export interface IThreeColumnGridProps {
  containItems: IKontentItem[];
  marginBetweenItems: SpaceBetweenColumnsType;
  wrappTwoColumns: DeviceType;
  wrappOneColumn: DeviceType;
  sameColumnsWidth: boolean;
}

const cx = classNames.bind(styles);

export const ThreeColumnGrid: FunctionComponent<IThreeColumnGridProps> = ({
  containItems,
  marginBetweenItems,
  wrappTwoColumns,
  wrappOneColumn,
  sameColumnsWidth
}) => {
  const { state } = useContext(AppStore);
  const { showActiveDevice } = state;
  const marginBetweenItemsClass = marginBetweenItemsClasses(marginBetweenItems);

  const checkTwoColumns = (): boolean => {
    if (
      showActiveDevice > checkDevice(wrappOneColumn) ||
      !wrappOneColumn.length
    ) {
      if (showActiveDevice <= checkDevice(wrappTwoColumns)) {
        return true;
      }
    }

    return false;
  };

  const sectionClass = cx({
    ...marginBetweenItemsClass,
    twoColumns: checkTwoColumns(),
    oneColumn:
      wrappOneColumn.length && showActiveDevice <= checkDevice(wrappOneColumn),
    sameColumnsWidth
  });

  return (
    <div className={`${styles.threeColumnGrid} ${sectionClass}`}>
      {containItems.map((item, i) => (
        <Section linkedItem={item} key={i} />
      ))}
    </div>
  );
};
